import { useT } from "@transifex/react";
import PhaseSixIcon from "../../basic/phaseSixIcon/PhaseSixIcon";
import { getTeacherSubline } from "../../helpers/schoolClassHelpers";
import type { TeacherInfo } from "../../networking/schoolClasses";

interface ClassroomTopBarProps {
    schoolClassName: string;
    teacher: TeacherInfo | null;
    onLogout: () => void;
}

export const ClassroomTopBar = (props: ClassroomTopBarProps) => {
    const t = useT();

    const t_classroomWithName = t("Classroom {className}", {
        _tags: "ClassMemberDashboard, ClassroomTopBar",
        className: props.schoolClassName,
    });
    const t_logout = t("Logout", { _tags: "ClassMemberDashboard, ClassroomTopBar" });

    const teacherSubline = getTeacherSubline(props.teacher, t);

    return (
        <div className="w-full flex items-start justify-between gap-s flex-wrap">
            <div className="flex flex-col gap-xxs min-w-0 flex-1">
                <p className="text-l font-semibold text-p6-grey-dark break-words">{t_classroomWithName}</p>
                {teacherSubline && <p className="text-m text-p6-grey-dark break-words">{teacherSubline}</p>}
            </div>
            <button
                type="button"
                onClick={props.onLogout}
                data-testid="classroom-logout"
                className="flex items-center gap-xs text-l text-p6-grey-dark hover:text-p6-grey-darkest shrink-0 cursor-pointer"
            >
                <span>{t_logout}</span>
                <PhaseSixIcon
                    name="logout"
                    className="text-xl"
                    aria-hidden="true"
                />
            </button>
        </div>
    );
};
